import { ca } from '@cian/analytics';

import { TStyle } from '../../repositories/chats/entities/action_button_v3/ActionButtonV3Schema';
import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export const trackActionButtonClick = (
  messageId: string,
  chatId?: string,
  buttonName?: string,
  communicationId?: string,
  offer?: TOffer,
  buttonLink?: string | null,
  buttonStyle?: TStyle,
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'ActionButton',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        chat_id: chatId,
        messages_id: messageId,
        communication_id: communicationId,
        button_style: buttonStyle,
        button_name: buttonName,
        button_link: buttonLink,
      },
    },
  });
};
